module.exports = __webpack_public_path__ + "img/HongXiao.4ead206a.png";